import { StatusColorEnum } from './StatusColorEnum'
import { HouseStatus } from '../../../../lib/graphql'

export const badgeColorByHouseStatus = (houseStatus: HouseStatus) => {
  switch (houseStatus) {
    case HouseStatus.DRAFT:
      return StatusColorEnum.GREY
    case HouseStatus.PUBLISHED:
      return StatusColorEnum.GREEN
    case HouseStatus.ARCHIVED_BANNED:
    case HouseStatus.ARCHIVED_OWNER:
      return StatusColorEnum.ORANGE
  }
}
